import { SelectOption } from '@globaleris/ui.library'
import { TaskModel } from '../../api/Argentia/endpoints/tasks/model/tasks'
import { EnumCriticidad } from '../../api/oData/enums/enumCriticidad'

export interface TaskAddEditFormModel extends TaskModel {
  relatedEntityCode?: string
}

export interface TaskCommentListModel {
  imgPath: string
  id?: number
  description: string
  user: string
  date: string
}

export interface GlobalerisClientModel {
  id: number
  domain: string
  privateArea?: string | null
  database: string
  icon: string
  urlLanding: string
  cssSheet?: string | null
}

export interface TaskTypeSelectOption extends SelectOption {
  code: string
  description: string
  criticality: EnumCriticidad
}

export enum TaskPageTabs {
  NUEVA = 1,
  EN_CURSO,
  FINALIZADA
}
